export default [
  {
    path: '/app/gsencuesta/institucion',
    name: 'app-administracion-institucion',
    component: () => import('@/views/GSEncuesta/Institucion/InstitucionList.vue'),
    meta: {
      resource: 'app-administracion-institucion',
      pageTitle: 'Institución',
      breadcrumb: [
        {
          text: 'Administración',
        },
        {
          text: 'Institución',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/gsencuesta/proyecto',
    name: 'app-administracion-proyecto',
    component: () => import('@/views/GSEncuesta/Proyecto/ProyectoList.vue'),
    meta: {
      pageTitle: 'Dependencia',
      resource: 'app-administracion-proyecto',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Administración',
        },
        {
          text: 'Dependencia',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/gsencuesta/grupo_opcion',
    name: 'app-mantenimiento-grupopcion',
    component: () => import('@/views/GSEncuesta/GrupoOpcion/GrupoOpcion.vue'),
    meta: {
      pageTitle: 'Grupo Opción',
      resource: 'app-mantenimiento-grupopcion',
      breadcrumb: [
        {
          text: 'Mantenimiento',
        },
        {
          text: 'Grupo Opción',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/gsencuesta/bloque',
    name: 'app-mantenimiento-bloque',
    component: () => import('@/views/GSEncuesta/Bloque/BloqueList.vue'),
    meta: {
      pageTitle: 'Bloque',
      resource: 'app-mantenimiento-bloque',
      breadcrumb: [
        {
          text: 'Mantenimiento',
        },
        {
          text: 'Bloque',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/gsencuesta/ubigeo',
    name: 'app-mantenimiento-ubigeo',
    component: () => import('@/views/GSEncuesta/Ubigeo/Ubigeo.vue'),
    meta: {
      pageTitle: 'Ubigeo',
      resource: 'app-mantenimiento-ubigeo',
      breadcrumb: [
        {
          text: 'Mantenimiento',
        },
        {
          text: 'Ubigeo',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/gsencuesta/encuestado',
    name: 'app-encuesta-encuestado',
    component: () => import('@/views/GSEncuesta/Encuestado/EncuestadoList.vue'),
    meta: {
      resource: 'app-encuesta-encuestado',
      pageTitle: 'Encuestado',
      breadcrumb: [
        {
          text: 'Encuesta',
        },
        {
          text: 'Encuestado',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/gsencuesta/encuestador',
    name: 'app-encuesta-encuestador',
    component: () => import('@/views/GSEncuesta/Encuestador/EncuestadorList.vue'),
    meta: {
      resource: 'app-encuesta-encuestador',
      pageTitle: 'Encuestador',
      breadcrumb: [
        {
          text: 'Encuesta',
        },
        {
          text: 'Encuestador',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/gsencuesta/encuesta',
    name: 'app-encuesta-encuesta',
    component: () => import('@/views/GSEncuesta/Encuesta/EncuestaList.vue'),
    meta: {
      resource: 'app-encuesta-encuesta',
      pageTitle: 'Encuestas',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Encuesta',
        },
        {
          text: 'Encuestas',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/gsencuesta/parcela',
    name: 'app-cultivo-parcela',
    component: () => import('@/views/GSEncuesta/Parcelas/Parcela.vue'),
    meta: {
      resource: 'app-cultivo-parcela',
      contentRenderer: 'sidebar-left',
      contentClass: 'email-application',
    },
  },
  /* {
    path: '/app/gsencuesta/parcela',
    name: 'app-cultivo-parcela',
    component: () => import('@/views/GSEncuesta/Parcela/ParcelaList.vue'),
    meta: {
      resource: 'app-cultivo-parcela',
      pageTitle: 'Parcela',
      breadcrumb: [
        {
          text: 'Cultivo',
        },
        {
          text: 'Parcela',
          active: true,
        },
      ],
    },
  }, */
  {
    // path: '/app/gsencuesta/parcela-view',
    path: '/app/gsencuesta/parcela-view/:id',
    name: 'app-cultivo-parcela-view',
    component: () => import('@/views/GSEncuesta/Parcela/ParcelaView.vue'),
    meta: {
      // resource: 'app-cultivo-parcela-view',
      pageTitle: 'Visor Parcela',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Cultivo',
        },
        {
          text: 'Visor Parcela',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/gsencuesta/encuestapregunta/:id',
    name: 'app-encuesta-pregunta',
    component: () => import('@/views/GSEncuesta/Encuesta/Pregunta/PreguntaList.vue'),
    meta: {
      pageTitle: 'Pregunta',
      resource: 'app-encuesta-pregunta',
      breadcrumb: [
        {
          text: 'Encuesta',
        },
        {
          text: 'Preguntas',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/gsencuesta/dashboard/visor',
    name: 'app-dashboard-visor',
    component: () => import('@/views/GSEncuesta/Dashboard/Visor.vue'),
    meta: {
      resource: 'app-dashboard-visor',
    },
  },
  {
    path: '/app/gsencuesta/dashboard/indicadores',
    name: 'app-dashboard-indicadores',
    // component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
    component: () => import('@/views/GSEncuesta/Indicadores/Indicadores.vue'),
    meta: {
      resource: 'app-dashboard-indicadores',
      contentClass: 'ecommerce-application',
    },
  },
  {
    path: '/app/gsencuesta/reporte/encuestador',
    name: 'app-reporte-encuestador',
    // component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
    component: () => import('@/views/GSEncuesta/ReporteEncuestador/ReporteEncuestador.vue'),
    meta: {
      resource: 'app-reporte-encuestador',
      contentClass: 'ecommerce-application',
    },
  },
  {
    path: '/app/gsencuesta/usuario',
    name: 'apps-seguridad-usuario',
    component: () => import('@/views/GSEncuesta/Usuario/UsuarioList.vue'),
    meta: {
      resource: 'apps-seguridad-usuario',
      pageTitle: 'Usuario',
      breadcrumb: [
        {
          text: 'Seguridad',
        },
        {
          text: 'Usuario',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/gsencuesta/sistema',
    name: 'apps-seguridad-sistema',
    component: () => import('@/views/palmas/seguridad/sistema/Sistema.vue'),
    meta: {
      resource: 'apps-seguridad-sistema',
      pageTitle: 'Sistema',
      breadcrumb: [
        {
          text: 'Seguridad',
        },
      ],
    },
  },
]
